import { FC, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { AccessDeniedMessage, PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";
import {
  DrawerType,
  isSupplierPriceRatesPasswordVerifiedAtom,
  useDrawers,
} from "@ryde/shared";

export const SupplierPriceRatesPage: FC = () => {
  const navigate = useNavigate();
  const { openDrawer } = useDrawers();
  const isPasswordVerified = useRecoilValue(
    isSupplierPriceRatesPasswordVerifiedAtom,
  );
  const hasOpenedDrawerRef = useRef(false);

  useEffect(() => {
    if (!isPasswordVerified && !hasOpenedDrawerRef.current) {
      hasOpenedDrawerRef.current = true;
      openDrawer({
        drawerProps: {
          type: DrawerType.SupplierPriceRatesPassword,
        },
      });
      navigate("/");
    }
    if (isPasswordVerified) {
      hasOpenedDrawerRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPasswordVerified]);

  if (!isPasswordVerified) {
    return <AccessDeniedMessage />;
  }

  return (
    <PageContextWrapper entity="supplierPriceRate">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
